export default class Logger {
  static log(...params: any): void {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log(...params);
    }
  }
}
